export const UTILISATEUR_REDUCER_NAME = 'utilisateurs';

export const UTILISATEUR_SLICE_NAME = 'utilisateurs';

export const SERVICES_SLICE_NAME = 'services';

export const POLES_SLICE_NAME = 'poles';

export const MARQUES_SLICE_NAME = 'marques';

export const GROUPES_SLICE_NAME = 'groupes';

export const ANTENNES_SLICE_NAME = 'antennes';

export const GROUPE_TRAVAIL_SLICE_NAME = 'groupeTravail';

export const UTILISATEUR_GROUPE_TRAVAIL_SLICE_NAME = 'utilisateursGroupeTravail';

export const DOMAINES_SLICE_NAME = 'domaines';

export const UTILISATEUR_AUTOSEARCH_DATASOURCE_NAME = 'autosearch';

export const GROUPE_TRAVAIL_ACTIVE_INSCRIPTION_DATASOURCE_NAME = 'groupeTravailActiveInscriptions';
